export default {
    disclaimer: {
        label_default: "Niniejszym potwierdzam i zgadzam się, że zamawiane/otrzymywane przeze mnie przedmioty są O-I własnością, która będzie wykorzystywana do O-I działań związanych z pracą, i w związku z tym O-I zastrzega sobie prawo do żądania zwrotu własności po moim opuszczeniu O-I (lub wcześniej, jeśli będzie to wymagane przez O-I).",
        label_type_1: "Potwierdzam, że samoocena pracy zdalnej została wypełniona dokładnie i w dobrej wierze, a wszelki sprzęt lub meble dostarczone z lokalizacji O-I lub zamówione za pośrednictwem Gear zostaną przeze mnie wykorzystane do celów mojej pracy z O-I. Przyjmuję do wiadomości i zgadzam się, że zamawiane/otrzymywane przeze mnie przedmioty są O-I własnością, która będzie wykorzystywana do O-I działań związanych z pracą, i w związku z tym O-I zastrzega sobie prawo do żądania zwrotu tej własności po moim opuszczeniu O-I (lub wcześniej, jeśli będzie to wymagane przez O-I).",
        errors: {
            required: "Proszę zaakceptować warunki użytkowania"
        }
    },
    cost_center: {
        label: "Kod centrum kosztów",
        placeholder: "Kod centrum kosztów",
        cost_center_not_found: "Brak centrów kosztów może potrwać do 24 godzin. Skontaktuj się z Globalnym Biurem Obsługi Klienta, jeśli nie widzisz odpowiedniego centrum kosztów.",
        errors: {
            regex: "Nieprawidłowy kod centrum kosztów"
        }
    },
    company_code: {
        label: "Kod spółki"
    },
    cost_center_name: {
        label: "Nazwa centrum kosztów"
    },
    order_note: {
        label: "Notatka do zamówienia",
        placeholder: "Opcjonalna notatka do zatwierdzenia dla menedżera",
    },
    send_emails_to_oobo_orderer: {
        "OOBO": "Powiadom mnie o aktualizacjach tego zamówienia"
    },
    "dell_banner":{
        label: "Ze względu na modernizację systemów firmy Dell, zamówienia złożone w firmie Dell między 1 a 14 sierpnia 2026 r. mogą ulec znacznym opóźnieniom w realizacji. Prosimy o uwzględnienie wydłużonego czasu realizacji zamówień w tym okresie. Dziękujemy za zrozumienie."
    }
}